import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const FirebaseLogin = () => {
    const { signInWithGoogle, error, loading, clearError } = useAuth();
    const [rememberMe, setRememberMe] = useState(true);
    const [isSigningIn, setIsSigningIn] = useState(false);

    const handleGoogleSignIn = async () => {
        try {
          setIsSigningIn(true);
          clearError();
          
          await signInWithGoogle({
            useRedirect: false,
            rememberMe
          });
        } catch (error) {
          console.error('Sign in failed:', error);
        } finally {
          setIsSigningIn(false);
        }
    };

  return (
    <>
        { true && ( 
            <div className="bg-white border border-gray-200 rounded-xl shadow-lg p-8 h-full lg:h-auto w-full max-w-full lg:max-w-md fixed z-50 left-0 lg:left-[calc(50%-200px)] top-0 lg:top-1/4 font-roboto">
                <h2 className="text-2xl font-semibold mb-2">Login</h2>
                <p className="text-gray-600 mb-4">Sign in to continue</p>
                <div class="border border-blue-300 rounded-xl mb-4 bg-blue-100 p-4 w-full max-w-full lg:max-w-md text-md">
                    <p class="flex text-blue-500 text-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 7.75V13M21.08 8.58v6.84c0 1.12-.6 2.16-1.57 2.73l-5.94 3.43c-.97.56-2.17.56-3.15 0l-5.94-3.43a3.15 3.15 0 0 1-1.57-2.73V8.58c0-1.12.6-2.16 1.57-2.73l5.94-3.43c.97-.56 2.17-.56 3.15 0l5.94 3.43c.97.57 1.57 1.6 1.57 2.73Z" stroke="#53a3f8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 16.2v.1" stroke="#53a3f8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span class="pl-2">Before you continue please know that</span>
                    </p>
                    <ul class="text-blue-500 list-disc px-4 py-2 font-light">
                        <li class="py-1">Third-party integrations may pose security risks.</li>
                        <li class="py-1">We use standard security practices, but full data protection cannot be guaranteed.</li>
                        <li class="py-1">We collect anonymous usage data to improve the app.</li>
                        <li class="py-1">This is still in early development.</li>
                    </ul>
                </div>

                <button 
                    onClick={handleGoogleSignIn}
                    // disabled={isSigningIn || loading}
                    className="flex items-center justify-center gap-2 bg-white text-gray-800 border border-gray-300 rounded-md py-2 px-4 hover:bg-gray-100 w-full"
                >
                    <svg width="18" height="18" viewBox="0 0 18 18">
                    <path fill="#4285F4" d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
                    <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
                    <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
                    <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
                    </svg>
                    Continue with Google
                </button>
                {/* <div className="flex items-center">
                    <input
                        id="remember-me"
                        name="remember-me"
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                        Keep me signed in
                    </label>
                </div> */}
            </div>
        )}

        {error && (
            <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-sm">
            {error}
            </div>
        )}

    </>
  );
};

export default FirebaseLogin;